import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import NotificationEmailConfigsAPI from '../../api/notificationEmailConfigs';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getEmailConfigs(_state) {
    return _state.records.sort((a, b) => (a.name || '').localeCompare(b.name));
  },
  getEmailConfigById: _state => id => {
    return _state.records.find(r => r.id === Number(id));
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, { isFetching: true });
    try {
      const response = await NotificationEmailConfigsAPI.get();
      commit(types.SET_NOTIFICATION_EMAIL_CONFIGS, response.data);
    } catch (error) {
      // Ignore
    } finally {
      commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  create: async ({ commit }, data) => {
    commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, { isCreating: true });
    try {
      const response = await NotificationEmailConfigsAPI.create(data);
      commit(types.ADD_NOTIFICATION_EMAIL_CONFIG, response.data);
      return response.data;
    } finally {
      commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, {
        isCreating: false,
      });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, { isUpdating: true });
    try {
      const response = await NotificationEmailConfigsAPI.update(id, updateObj);
      commit(types.EDIT_NOTIFICATION_EMAIL_CONFIG, response.data);
      return response.data;
    } finally {
      commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, {
        isUpdating: false,
      });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, { isDeleting: true });
    try {
      await NotificationEmailConfigsAPI.delete(id);
      commit(types.DELETE_NOTIFICATION_EMAIL_CONFIG, id);
    } finally {
      commit(types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG, {
        isDeleting: false,
      });
    }
  },

  test: async (_, id) => {
    return NotificationEmailConfigsAPI.test(id);
  },
};

export const mutations = {
  [types.SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.ADD_NOTIFICATION_EMAIL_CONFIG]: MutationHelpers.create,
  [types.SET_NOTIFICATION_EMAIL_CONFIGS]: MutationHelpers.set,
  [types.EDIT_NOTIFICATION_EMAIL_CONFIG]: MutationHelpers.update,
  [types.DELETE_NOTIFICATION_EMAIL_CONFIG]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
